module.exports = __webpack_public_path__ + "static/media/ramayana-menu.7b70fdf0.jpg";